//Theme Scripts

// Fixed navigation

document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector(".fixed");

  // Suoritetaan vain jos fixed-elementti löytyy
  if (navbar) {
    let prevScrollPos = window.scrollY;
    const scrollThreshold = 400;
    const colorThreshold = 1;

    window.onscroll = function() {
      let currentScrollPos = window.scrollY;

      if (prevScrollPos > currentScrollPos || currentScrollPos < scrollThreshold) {
        navbar.style.top = "0";
      } else {
        navbar.style.top = `-${navbar.offsetHeight}px`;
      }

      if (currentScrollPos >= colorThreshold) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }

      prevScrollPos = currentScrollPos;
    };
  }
});

// --- Ankkurilinkkien aktiivisen tilan hallinta (tämä osa pysyy samana) ---

  function setActiveAnchor(linkElement) {
    document.querySelectorAll('a[href^="#"].active-anchor').forEach(el => {
      el.classList.remove('active-anchor');
    });
    if (linkElement) {
      linkElement.classList.add('active-anchor');
    }
  }

  function updateActiveAnchorBasedOnHash(hash) {
    if (hash && hash !== '#') {
      try {
        const targetLink = document.querySelector(`a[href="${hash}"]`);
        setActiveAnchor(targetLink);
      } catch (e) {
        console.error("Virhe etsiessä ankkurilinkkiä hashilla:", hash, e);
        setActiveAnchor(null);
      }
    } else {
      setActiveAnchor(null);
    }
  }

  updateActiveAnchorBasedOnHash(window.location.hash);

  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function() {
      const targetId = this.hash;
      // Selain hoitaa skrollauksen CSS:n scroll-padding-top:n avulla
      if (targetId && targetId !== '#' && document.querySelector(targetId)) {
        setActiveAnchor(this);
      } else if (targetId && targetId !== '#' && !document.querySelector(targetId)) {
        setActiveAnchor(null);
      }
    });
  });

  window.addEventListener('hashchange', function() {
    updateActiveAnchorBasedOnHash(window.location.hash);
  });